import PropTypes from 'prop-types';
import {Enums} from '_app/utils';
import sectionShape from './sectionShape';

const mediaTypes = Enums.getType('mediaTypes');
const languages = Enums.getType('languages');
const mediaSources = Enums.getType('mediaSources');

export const media = {
	ID: PropTypes.number.isRequired,
	GlobalID: PropTypes.string,
	Name: PropTypes.string,
	Description: PropTypes.string,
	InternalDescription: PropTypes.string,
	OwnerId: PropTypes.number,
	Featured: PropTypes.bool,
	FeaturedUpdatedBy: PropTypes.string,
	Type: PropTypes.oneOf([
		mediaTypes.VIDEO,
		mediaTypes.PRESENTATION,
		mediaTypes.ARTICLE,
		mediaTypes.AUDIO,
		mediaTypes.EMAIL,
		mediaTypes.EBOOK,
		mediaTypes.INFOGRAPHIC,
		mediaTypes.ONESHEET,
		mediaTypes.NEWSLETTER,
	]).isRequired,
	Section: sectionShape,
	Language: PropTypes.oneOf([
		languages.ENGLISH,
		languages.SPANISH
	]),
	Keywords: PropTypes.string,
	IsFavorite: PropTypes.bool,
	PrimaryVersion: PropTypes.number,
	SourceID: PropTypes.number,
	SourceName: PropTypes.oneOf([
		mediaSources.EMA,
		mediaSources.FMEX
	]),
	SourceCode: PropTypes.string,
	CreateDate: PropTypes.instanceOf(Date),
	ModifyDate: PropTypes.instanceOf(Date),
	DeleteDate: PropTypes.instanceOf(Date),
	ShareTexts: PropTypes.array,
	Versions: PropTypes.array,
	SourceContentID: PropTypes.number,
	CreatedByID: PropTypes.string
};

export default PropTypes.shape(media);